import React, { Component } from 'react'
import Iframe from 'react-iframe';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTheme } from 'styled-components';
import lo from 'lodash'
import moment from 'moment'

import ButtonReg from 'atoms/Buttons/Button';
import IconPng from 'atoms/IconPng';
import { FormSelect } from 'atoms/Inputs';
import { Label } from 'atoms/Texts';
import { ReportTypesIMM } from 'fixtures/enums'
import Breadcrumb from 'molecules/Breadcrumb';
import CompanyFilter from 'molecules/CompanyFilter';
import { getContractorPitLookupData } from 'Redux/actions/LookupActions';
import { getAllUsersData } from 'Redux/actions/UserMgmtActions';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import {
  PageWrapper,
  RoundedWrapper,
  IframeWrapper,
  EmptyWrapper,
  FilterCol,
  FilterRow,
  StyledDatePicker,
} from './styles'

const { REPORT_URL } = process.env

const baseAllPits = [{
  name: 'All Pits',
  id: ''
}]

const ic_eye = require('App/assets/images/ic_eye.png')
const ic_folder = require('App/assets/images/ic_folder.png')

class ReportIMM extends Component {
  constructor(props) {
    super(props)

    this.state = {
      reportType: '-',
      date: new Date(),
      month: new Date(),
      lookups: {
        SHIFT_ID: props.shifts,
        CONTRACTOR_ID: [],
        PIT_ID: baseAllPits,
        USER_ID: [],
      },
      filter: {
        SHIFT_ID: '-',
        CONTRACTOR_ID: '-',
        PIT_ID: '-',
        USER_ID: '-',
      },
      reportUri: null,
      navList: [
        'Report',
        'Report IMM',
      ],
    }
  }

  componentDidMount() {
    this.props.toggleIsLoading(true)
    this.props.getContractorPitLookupData()
    this.props.getAllUsersData()
  }

  componentDidUpdate(prevProps) {
    const { contractorPitLookups, shifts, users } = this.props
    const { lookups } = this.state

    if (prevProps.contractorPitLookups !== contractorPitLookups) {
      lookups.CONTRACTOR_ID = contractorPitLookups
      this.setState({ lookups }, () => {
        this.props.toggleIsLoading(false)
      })
    }

    if (prevProps.users !== users) {
      lookups.USER_ID = users.filter((user) => user.originCompany.code === 'IMM').map((user) => ({ ...user, name: user.displayName }))
      this.setState({ lookups }, () => {
        this.props.toggleIsLoading(false)
      })
    }

    if (prevProps.shifts !== shifts) {
      lookups.SHIFT_ID = shifts
      this.setState({ lookups })
    }
  }

  getIframeHeight() {
    const w = window.innerWidth
    const h = window.innerHeight
    return w <= 768 ? `${h - 384}px` : `${h - 300}px`
  }

  onFilterChange = (val, field) => {
    const { filter } = this.state
    filter[field] = val
    this.setState({ filter }, () => {
      if (field === 'CONTRACTOR_ID') {
        const {
          filter: { CONTRACTOR_ID: contractorId },
          lookups: { CONTRACTOR_ID: contractors },
          lookups,
        } = this.state
        const { pits } = contractors.find((c) => c.id === parseInt(contractorId))
        lookups.PIT_ID = [...baseAllPits, ...pits]
        this.setState({ lookups })
      }
    })
  }

  onFilterSubmit() {
    const { reportType, date, month, filter } = this.state
    if (reportType === '-') return
    const reportTypeObj = ReportTypesIMM.find(t => t.id === reportType)
    const params = [
      ...reportTypeObj.filters
        .filter(f => f !== 'CONTRACTOR_ID')
        .filter(f => filter[f] !== '-')
        .map(f => `${f}=${filter[f]}`),
      ...(reportTypeObj.date ? [`DATE=${moment(date).format('YYYY-MM-DD')}`] : []),
      ...(reportTypeObj.month ? [`DATE=${moment(month).format('YYYY-MM-DD')}`] : []),
    ].join('&')
    this.setState({
      reportUri: `${REPORT_URL}${reportType}&${params}`,
    })
  }

  render() {
    const { reportType, date, month, filter, reportUri, lookups, navList } = this.state
    const { viewState: { isLoading, isMobileView }, theme } = this.props

    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: 'auto',
      yxPadding: '9px 12px',
      height: '34px',
      arrowSize: '16px',
      arrowPos: 'calc(100% - 12px)'
    }

    const reportTypeObj = ReportTypesIMM.find(t => t.id === reportType)
    const dateShown = reportTypeObj && reportTypeObj.date
    const monthShown = reportTypeObj && reportTypeObj.month

    const displayedFilters = reportTypeObj
      ? reportTypeObj.filters
      : Object.keys(filter)

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList}>
          <CompanyFilter />
        </Breadcrumb>
        {!isLoading &&
          <RoundedWrapper>
            <FilterRow>
              <FilterCol>
                <Label lineheight={'14px'} size={'12px'}>
                  Type
                </Label>
                <FormSelect
                  placeholder={`Select Type`}
                  onChangeVal={e => this.setState({ reportType: e.target.value })}
                  options={lo.sortBy(ReportTypesIMM, 'name')}
                  value={reportType}
                  valField={'id'}
                  dispField={'name'}
                  {...inputConfig}
                />
              </FilterCol>
              {displayedFilters.map((key, i) => {
                return (
                  <FilterCol key={i}>
                    <Label lineheight={'14px'} size={'12px'}>
                      {lo.capitalize(key.split('_')[0])}
                    </Label>
                    <FormSelect
                      placeholder={`Select ${lo.capitalize(key.split('_')[0])}`}
                      onChangeVal={e => this.onFilterChange(e.target.value, key)}
                      options={lookups[key]}
                      value={filter[key]}
                      valField={lookups[key].hasOwnProperty('value') ? 'value' : 'id'}
                      dispField={'name'}
                      {...inputConfig}
                    />
                  </FilterCol>
                )
              })}
              {dateShown &&
                <FilterCol>
                  <Label lineheight={'14px'} size={'12px'}>
                    Date
                  </Label>
                  <StyledDatePicker
                    onChange={date => this.setState({ date })}
                    value={date}
                  />
                </FilterCol>
              }
              {monthShown &&
                <FilterCol>
                  <Label lineheight={'14px'} size={'12px'}>
                    Month
                  </Label>
                  <StyledDatePicker
                    maxDetail="year"
                    onChange={month => this.setState({ month })}
                    value={month}
                  />
                </FilterCol>
              }
              <ButtonReg
                btnTxt={
                  <IconPng srcIcon={ic_eye} ml={'0'} mb={'3px'} size={'auto'} h={'13'} showPointer={true} />
                }
                rad={'6px'}
                onClick={this.onFilterSubmit.bind(this)}
                width={'34px'}
                height={'34px'}
              />
            </FilterRow>

            <div className={'mt-3'}>
              {reportUri ?
                <IframeWrapper>
                  <Iframe
                    url={reportUri}
                    width="100%"
                    height={this.getIframeHeight()}
                    display="initial"
                    position="relative"
                    frameBorder="0" />
                </IframeWrapper> :
                <EmptyWrapper className="text-center">
                  <div>
                    <IconPng srcIcon={ic_folder} size={'auto'} h={'86'} mb={'20px'} />
                  </div>
                  <Label weight={'600'} lineheight={'14px'} mb={'35px'} size={'12px'}>
                    Select “filter” and click “view” button to see the report
                  </Label>
                </EmptyWrapper>
              }
            </div>
          </RoundedWrapper>
        }
      </PageWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState,
    contractorPitLookups: state.contractorPitLookups,
    shifts: (state.userLogin && state.userLogin.userDetail && state.userLogin.userDetail.originCompany.companyShifts) || [],
    users: state.usersList,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getContractorPitLookupData,
      getAllUsersData,
      toggleIsLoading,
    },
    dispatch
  )

export default withTheme(
  connect(mapStateToProps, mapDispatchToProps)(ReportIMM)
)
